
<div class="dynamic-date-filter">
  <div class="dynamic-date-filter__option" @click="emitRadioChange('empty')">
    <div class="dynamic-date-filter__row">
      <input type="radio" :name="`date-filter-${filter.keys[0]}`" value="empty"
        :checked="radioValue === 'empty'">
      <span class="dynamic-date-filter__title">Empty</span>
    </div>
    <div class="dynamic-date-filter__description">
        <i> No filter date selected</i>
    </div>
  </div>

  <div class="dynamic-date-filter__option" @click="emitRadioChange('dynamic')">
    <div class="dynamic-date-filter__row">
      <input type="radio" :name="`date-filter-${filter.keys[0]}`" value="dynamic"
        :checked="radioValue === 'dynamic'">
      <span class="dynamic-date-filter__title">Dynamic Date</span>
    </div>
  </div>

  <div v-if="radioValue === 'dynamic'" class="dynamic-date-filter__nested">
    <div v-for="preset in presets" :key="preset.id" class="dynamic-date-filter__preset"
      @click="emitPresetSelect(preset.id)">
      <div class="dynamic-date-filter__row">
        <input type="radio" :name="`dynamic-preset-${filter.keys[0]}`" :value="preset.id"
          :checked="isPresetSelected(preset.id)">
        <span>{{ preset.label }}</span>
      </div>
      <div v-if="getPresetPreview(preset.id)" class="dynamic-date-filter__preview">
        {{ getPresetPreview(preset.id) }}
      </div>
    </div>

    <div v-if="isPresetSelected('dynamic_custom')" class="dynamic-date-filter__custom">
      <span class="dynamic-date-filter__custom-prefix">{{ dynamicPrefix }}</span>
      <div class="dynamic-date-filter__custom-number" @keydown="preventMinusKey">
        <CInput ref="customNumberInput" :value="customValue" type="number" :input-min="1" :input-max="customMax"
          @input="emitCustomValueInput" placeholder="1234" />
      </div>
      <div class="dynamic-date-filter__custom-unit">
        <CSelectNew :value="customUnit" @input="emitCustomUnitInput" :options="unitOptions" item-text="text"
          item-value="value" placeholder="Select unit">
        </CSelectNew>
      </div>
    </div>

    <div v-if="noteText" class="dynamic-date-filter__note">
      <strong>Note:</strong> {{ noteText }}
    </div>
  </div>

  <div class="dynamic-date-filter__option" @click="emitRadioChange('absolute')">
    <div class="dynamic-date-filter__row">
      <input type="radio" :name="`date-filter-${filter.keys[0]}`" value="absolute"
        :checked="radioValue === 'absolute'">
      <span class="dynamic-date-filter__title">Static Date</span>
    </div>
    <div class="dynamic-date-filter__description">
        <i>Use a fixed start and end date.</i>
    </div>
  </div>

  <div v-if="radioValue === 'absolute'" class="dynamic-date-filter__static">
    <div class="dynamic-date-filter__static-title">Custom Static Date</div>
    <div class="dynamic-date-filter__static-inputs">
      <div>
        <label class="form-label mb-1 dynamic-date-filter__date-label">Start Date</label>
        <CInput :value="startValue" type="date" placeholder="mm/dd/yyyy"
          style="width: 142px !important;" @input="emitStartDateInput" />
      </div>
      <div v-if="filter.keys.length > 1">
        <label class="form-label mb-1 dynamic-date-filter__date-label">End Date</label>
        <CInput :value="endValue" type="date" placeholder="mm/dd/yyyy"
          :min-date="startValue" style="width: 142px !important;" @input="emitEndDateInput" />
      </div>
    </div>
  </div>
</div>
